/* global $:true */
import debug from "debug";
import plugin from '../../lib/plugin';

const ELEMENT_SELECTOR = '[data-address-validation]';
const FORM_WRAPPER_SELECTOR = 'data-form-wrapper-element';
const ADDRESS_LINE_0_SELECTOR = '.address-line-0';
const PLUGIN_NAME = 'addressValidation';
const MODULE_NAME = 'app.core/modules/address-validation';
const log = debug(MODULE_NAME);


import googleMapsApiPromise from '../../services/google-maps-api';

log('registerd');

class AddressValidation {

 constructor(element, options) {
		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.$parentEl = $(this.$element.attr(FORM_WRAPPER_SELECTOR));
		this.$addressLine0 = this.$parentEl.find(ADDRESS_LINE_0_SELECTOR);
		this.isInitiated = false;
		this.hasWaited = false;
        this.inputElement = document.getElementById(options.fieldId);

		log('construct', element);
		this.preventSubmit();
		this.watchGoogleMapApiError();
		this.checkForInit();
		this.initGoogleMaps();

	}

	initGoogleMaps() {
		googleMapsApiPromise.then((google) => {
			log('googleMapsApiPromise');
			this.google = google;
			this.init();
			this.isInitiated = true;
		}).catch((reason) => {
			if (typeof(window.google) !== 'undefined') {
				console.log('googleMapsApiPromise timeout. Setting from window.');
				this.google = window.google;
				this.init();
				this.isInitiated = true;
			}
		});
	}

	watchGoogleMapApiError () {
		const oldError = console.error;
		// Stops the input field from being disabled if issue with API
		const $element = this.$element;
		console.error = function (message) {
			if (message.toLowerCase().includes("google maps api error")) {
				$element.removeAttr('disabled');
				$element.attr('placeholder', '');
				$element.removeAttr('style', '');
				$element.parent().find('.field-validation-valid').hide();
			}

			oldError.apply(console, arguments);
		};
	}

	preventSubmit () {

		if (this.$element.closest('form').length) {
			log('preventSubmit.enabled [Preventing form submission on ENTER press.]');

			this.$element.on('keypress', (event) => {
				if (event.keyCode === 13) {
					event.preventDefault();
					log('preventSubmit.keypress', event.keyCode);
				}
			});
		}
	}

	checkForInit() {
		const mod = this;
		setTimeout(function(){
			mod.hasWaited = true;
		}, 2000);

		this.$element.on('focus', function() {
			if (!mod.isInitiated && mod.hasWaited) {
				mod.initGoogleMaps();
			}
		});
	}

	init () {
        this.element.includedRegionCodes = [this.options.countryCode];

		this.element.addEventListener('gmp-select', this.fillInAddress.bind(this));

		log('init');
	}

	fillInAddress(event) {
		const place = event.placePrediction.toPlace();
		place.fetchFields({
            fields: ['formattedAddress', 'location', 'addressComponents'],
        }).then(this.fillInAddressAfterFetch.bind(this, place));
	}

    fillInAddressAfterFetch(place) {
        const elementVal = this.$element.val();
        log('fillInAddress', place);
        this.$element.trigger({type: 'place_selected', place});
        for (let component in this.options.componentForm) {
            let compElement = this.$parentEl.find('.' + component);
            if (typeof(compElement) !== 'undefined' && compElement.length > 0) {
                compElement.val('');
                compElement.attr('disabled', false);
            }
        }

        let addressLine0 = '';
        let addressLine1 = '';
        let premise = '';
        let subpremise = '';
        let route = '';
        let postBox = '';
        let postalTown = '';
        let administrative_area_level_2 = '';
        let locality = '';
        let fullAddress = place.formattedAddress;

        for (let addressComponent of place.addressComponents) {
            let addressType = addressComponent.types[0];
            let compElement =  this.$parentEl.find('.' + addressType);

            if (addressType == 'post_box') {
                postBox = addressComponent[this.options.componentForm['post_box']];
            }
            if (addressType == 'premise') {
                premise = addressComponent[this.options.componentForm['premise']];
            }
            if (addressType == 'subpremise') {
                subpremise = addressComponent[this.options.componentForm['subpremise']];
            }
            if (addressType == 'street_number') {
                addressLine1 = addressLine1.length == 0
                    ? addressComponent[this.options.componentForm['street_number']]
                    : addressLine1;
            }
            if (addressType == 'route') {
                route = addressComponent[this.options.componentForm['route']];

                // Retain unit numbers entered in form.
                const regex = RegExp('^(.*)'+route.split(' ',1)[0]),
                result = regex.exec(elementVal);

                if (Array.isArray(result)) {
                    addressLine1 = result[1];
                }
            }
            if (addressType == 'postal_town') {
                postalTown = addressComponent[this.options.componentForm['postal_town']];
            }
            if (addressType == 'locality' || addressType =='colloquial_area') {
                locality = addressComponent[this.options.componentForm['locality']];
            }
            if (addressType == 'administrative_area_level_2') {
                administrative_area_level_2 = addressComponent[this.options.componentForm['administrative_area_level_2']];
            }
            if (this.options.componentForm[addressType] && typeof(compElement) !== 'undefined' && compElement.length > 0) {
                const val = addressComponent[this.options.componentForm[addressType]];
                compElement.val(val);
            }
        }

        let latitudeElement =  this.$parentEl.find('.latitude');
        let longitudeElement =  this.$parentEl.find('.longitude');
        if (typeof(latitudeElement) !== 'undefined' && latitudeElement.length > 0) {
            latitudeElement.val(place.location.lat());
        }
        if (typeof(longitudeElement) !== 'undefined' && longitudeElement.length > 0) {
            longitudeElement.val(place.location.lng());
        }

        if (locality.length == 0) {
            locality = postalTown;
        }
        if (locality.length == 0) {
            locality = administrative_area_level_2;
        }

        let localityEl =  this.$parentEl.find('.locality');
        if (typeof(localityEl) !== 'undefined') {
            localityEl.val(locality);
        }
        let add0 = subpremise.length > 0 ? subpremise + ' ' : '';
        add0 = add0.length > 0 ? add0 : addressLine0;
        add0 = add0.trim();

        let add1 = postBox.length > 0 ? 'PO BOX ' + postBox + ' ' : '';
        add1 += premise.length > 0 ? premise + ' ' : '';
        add1 += addressLine1.length > 0 ? addressLine1 + ' ' : '';
        add1 += route;
        add1 = add1.trim();

        if (typeof(this.$addressLine0) !== 'undefined' && this.$addressLine0.length > 0) {
            this.$addressLine0.val(add0);
        }

        if(add1.length > 0) {
            this.inputElement.value = add1;
        } else {
            this.inputElement.value = fullAddress;
        }
        $(this.inputElement).trigger('change');

        $( document ).trigger('address-validation-complete');
    }
}

AddressValidation.DEFAULTS = {
	componentForm:  {
		post_box: 'longText',
		premise : 'longText',
		subpremise: 'longText',
		street_number: 'shortText',
		sublocality_level_1: 'shortText',
		route: 'longText',
		locality: 'longText',
		administrative_area_level_1: 'shortText',
		administrative_area_level_2: 'shortText',
		country: 'shortText',
		postal_code: 'shortText',
		postal_town: 'shortText',
	},
	countryCode: $(`meta[name="site.countryCode"]`).attr('content')
};

plugin(PLUGIN_NAME, AddressValidation);

export function exec () {
  $(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();

  });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/address-validation/index.js